import { useState } from "react";

const ALLOWED_STUDENT_ID_CARD_TYPES = [
  "image/jpeg",
  "image/jpg",
  "application/pdf",
];

const MAX_STUDENT_ID_CARD_SIZE_BYTES = 5 * 1024 * 1024;

export const useStudentIdCardUpload = ({ setFormData }) => {
  const [studentIdCardFile, setStudentIdCardFile] = useState(null);
  const [studentIdCardError, setStudentIdCardError] = useState("");

  const handleStudentIdCardUpload = async (event) => {
    if (event.target.files.length > 1) {
      setStudentIdCardError("Please upload only one file");
      event.target.value = "";
      return;
    }

    const file = event.target.files[0];

    if (!file) {
      setStudentIdCardFile(null);
      setStudentIdCardError("");
      setFormData((prev) => ({
        ...prev,
        studentIdCard: null,
        studentIdCardName: "",
        studentIdCardType: "",
      }));
      return;
    }

    if (!ALLOWED_STUDENT_ID_CARD_TYPES.includes(file.type)) {
      setStudentIdCardError("Please upload only JPEG or PDF files");
      event.target.value = "";
      return;
    }

    if (file.size > MAX_STUDENT_ID_CARD_SIZE_BYTES) {
      setStudentIdCardError("File size must be less than 5MB");
      event.target.value = "";
      return;
    }

    setStudentIdCardError("");
    setStudentIdCardFile(file);

    try {
      const reader = new FileReader();
      reader.onloadend = () => {
        const base64String = reader.result;
        setFormData((prev) => ({
          ...prev,
          studentIdCard: base64String,
          studentIdCardName: file.name,
          studentIdCardType: file.type,
        }));

        console.log("Student ID card loaded, size:", file.size, "bytes");
      };

      reader.onerror = () => {
        console.error("Error reading file");
        setStudentIdCardError("Failed to read file. Please try again.");
        event.target.value = "";
        setStudentIdCardFile(null);
      };

      reader.readAsDataURL(file);
    } catch (error) {
      console.error("Error processing student ID card:", error);
      setStudentIdCardError("Failed to process file. Please try again.");
      event.target.value = "";
      setStudentIdCardFile(null);
    }
  };

  return {
    studentIdCardFile,
    setStudentIdCardFile,
    studentIdCardError,
    setStudentIdCardError,
    handleStudentIdCardUpload,
  };
};
